import { exibirMensagem, exibirErros } from "componentes/mensagem/actions";
export const ADICIONAR_ANEXO = "anexo/ADICIONAR_ANEXO";
export const LIMPAR_ANEXO = "anexo/LIMPAR_ANEXO";
export const LIMPAR_ANEXO_LOCAIS = "anexo/LIMPAR_ANEXO_LOCAIS";

export const adicionarAnexo = anexo => dispatch => {
  if (anexo) {
    dispatch({
      type: ADICIONAR_ANEXO,
      anexo: anexo.id
        ? { ...anexo, type: anexo.nome.replace(/^.*(\..*$)/, "$1") }
        : anexo
    });
  }
}

export const salvarAnexosDiretamente = evento => (dispatch, getState) => {
  evento.preventDefault();
  const { anexos } = getState().anexo;
  const { processo: { id: processoId } } = getState().processo;
  dispatch(salvarAnexos(processoId, anexos))
    .then(arquivosJson => arquivosJson
      .forEach(anexo => {
        if (anexo.msg) {
          dispatch(exibirMensagem({ msg: anexo.msg, tipo: "error" }));
        }
        else {
          dispatch(adicionarAnexo(anexo));
          dispatch(exibirMensagem({ msg: `Anexo ${anexo.nome} cadastrado com sucesso!`, tipo: "success" }));
        }
      }))
    .catch(erros => dispatch(exibirErros(erros)));
}

export const salvarAnexos = (processoId, anexos) => dispatch => {
  const arquivosParaSalvar = anexos.filter(anexo => !anexo.id);
  if (arquivosParaSalvar.length > 0) {
    let msg = "Salvando anexos,";
    const promessas = arquivosParaSalvar
      .map(anexo => {
        msg = `${msg} nome: ${anexo.name}`;
        const formData = new FormData();
        formData.append("filename", anexo, anexo.name);
        return fetch(`/services/api/processos/${processoId}/anexos`, { method: "POST", body: formData });
      });

    dispatch(exibirMensagem({ msg, tipo: "warning" }));
    return Promise.all(promessas)
      .then(arquivosResponse => {
        dispatch({ type: LIMPAR_ANEXO_LOCAIS });
        return Promise.all(
          arquivosResponse.map(ar => ar.ok
            ? ar.json()
            : Promise.resolve({ msg: `${ar.status} - ${ar.statusText}` })))
      })
  }
  return Promise.resolve([]);
}


// WEBPACK FOOTER //
// ./src/componentes/anexo/actions.js